import React, { useState } from 'react'
import { 
  Button,
  Grid,
  makeStyles,
  Step,
  StepLabel,
  Stepper,
} from '@material-ui/core';
import { confirmSolicitudLaboratorio, getSolicitudesLaboratorio, laboratorioClear } from '../../../../actions/turnos/laboratorio';
import { PracticasLaboratorioSeleccionadas } from './steps/PracticasLaboratorioSeleccionadas';
import { DiagnosticoFechaLaboratorio } from './steps/DiagnosticoFechaLaboratorio';
import { PracticasLaboratorioTabla } from './steps/PracticasLaboratorioTabla';
import { DocumentacionLaboratorio } from './steps/DocumentacionLaboratorio';
import { changeStepper } from '../../../../actions/preAfiliado/stepper';
import { desSeleccionarAfiliado } from '../../../../actions/afiliado';
import { AfiliadoLaboratorio } from './steps/AfiliadoLaboratorio';
import { OBRAS_SOCIALES } from '../../../../utils/constants';
import { startAlerta } from '../../../../actions/ui/alertas';
import { AfiliadoTurno } from '../../nuevo/AfiliadoTurno';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import AlertaMail from '../../../empadronamiento/UI/AlertaMail';
import { SolicitudesLaboratorio } from './SolicitudesLaboratorio';
import { DatosCentroEspecialidadHce } from './steps/DatosCentroEspecialidadHce';
import { GruposLaboratorio } from './steps/GruposLaboratorio';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: -30,
    marginBottom: 10,
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  rootListadoc: {
    margin: 30,
  },
  practicas: {
    padding:10,
    marginTop: 15,
    backgroundColor: theme.palette.background.paper,
  },
  rootBotonera: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "70%",
  },
  botonera: {
      marginTop: 50,
      marginBottom: 20,
      paddingBottom: 13
  },
}));

function getSteps() {
  return [
    "Afiliado / Centro",
    "Contacto Afiliado",
    "Grupo",
    "Prácticas",
    "Autorización",
    "Documentación",
  ];
}


export const StepperLaboratorio = ({fecha, closeModal, horariosDemandaValidos, 
  addedPracticasAndAbonar, desdeHce = false, hce}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { step } = useSelector((state) => state.stepper);
  const { seleccionado, afiliado } = useSelector((state) => state.afiliacion);
  const { 
    documentacion, 
    solicitudesAutorizadas,
    practicasSeleccionadas: practicas, 
  } = useSelector((state) => state.laboratorio);

  const [diagnostico, setDiagnostico] = useState(null);
  const [openModalEnCarga, setOpenModalEnCarga] = useState(false);
  const [openModalPregunta, setOpenModalPregunta] = useState(false);
  const [fechaPrescripcion, setFechaPrescripcion] = useState(new Date());
  const [idObraSocial, setIdObraSocial ] = useState(OBRAS_SOCIALES.OSPEDYC);
  const [datosCompletosDiagnostico, setDatosCompletosDiagnostico] = useState(false);
  const [parametrizacionSeleccionada, setParametrizacionSeleccionada] = useState({});
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);

  const steps = getSteps();

  const handleNext = () => {
    switch (step) {
      case 0:
        dispatch(changeStepper(step + 1));
        dispatch( getSolicitudesLaboratorio(afiliado.id_afiliado, parametrizacionSeleccionada.idCentro, null) );
        break;
      case 1:
        if(!parametrizacionSeleccionada?.idEspecialidad || (!parametrizacionSeleccionada?.idCentro && !desdeHce))
          return dispatch(
            startAlerta(
              `Debe seleccionar 
              ${!parametrizacionSeleccionada?.idEspecialidad 
                ? "la Especialidad."
                : "el Centro Médico." 
              }`,
              "error",
              "Error"
            )
          );
        if(afiliado.fecha_fin_cobertura === null || 
          moment(fecha.toISOString()).isSameOrBefore(moment(afiliado.fecha_fin_cobertura).add(1, 'days'))){
            document.querySelector(`#btnSubmitDatosTurnos`).click();
            if(solicitudesAutorizadas.length > 0) setOpenModalEnCarga(true)
          }
        else
          dispatch(startAlerta("Beneficiario/a con cobertura inactiva  para la fecha seleccionada", "error", "Error"));
        break;
      case 2:
        document.querySelector(`#btnSubmitLaboratorioStep2`).click();        
        break;
      case 3:
        document.querySelector(`#btnSubmitLaboratorioStep3`).click();        
        break;
      case 4:        
        if(practicas.filter(s => !s.autorizada).length > 0)
          setOpenModalPregunta(true);
        else
          dispatch(changeStepper(step + 1));
        break;
      case 5:
        if(!datosCompletosDiagnostico || (!datosCompletosDocumentacion && !desdeHce) || !fechaPrescripcion)
          return dispatch(
            startAlerta(
              `Debe completar 
              ${!datosCompletosDiagnostico 
                ? "el diagnostico." 
                : (!datosCompletosDocumentacion && !desdeHce)
                  ? "la documentación."
                  : "la fecha."
              }`,
              "error",
              "Error"
            )
          );

        const solic = {
          desdeHce,
          practicas,
          documentacion,
          fechaPrescripcion,
          idAfiliado: afiliado.id_afiliado,
          idDiagnostico: diagnostico.idProblema,
          idEfectorGeneracion: desdeHce ? hce?.idEfector : null,
          idCentroMedico: parametrizacionSeleccionada.idCentro,
          idEfHorario: parametrizacionSeleccionada.idEfHorario,
          idEspecialidad: parametrizacionSeleccionada.idEspecialidad,
        }
        dispatch( confirmSolicitudLaboratorio(solic, addedPracticasAndAbonar, closeModal) );
        break;  
      default:
        break;
    }
  };

  const handleBack = () => {
    dispatch( changeStepper(step - 1) );
    if( step === 1){
      dispatch( desSeleccionarAfiliado() );
      dispatch( laboratorioClear() );
    }
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid item xs={12} style={{ marginTop: -15 }}>
            <AfiliadoLaboratorio
              hce={hce}
              fecha={fecha}
              desdeHce={desdeHce}
              idObraSocial={idObraSocial}
              setIdObraSocial={setIdObraSocial}
              horariosDemandaValidos={horariosDemandaValidos}
              parametrizacionSeleccionada={parametrizacionSeleccionada}
              setParametrizacionSeleccionada={setParametrizacionSeleccionada}
            />            
          </Grid>
        );
      case 1:
        return (
          <>
            {seleccionado && afiliado &&
              <Grid item xs={12} style={{ marginTop: -25 }}>
                <AfiliadoTurno 
                  idObraSocial={idObraSocial} 
                  setIdObraSocial={setIdObraSocial} 
                />
                
              </Grid>
            }
            {desdeHce &&
              <DatosCentroEspecialidadHce 
                hce={hce}
                desdeHce={desdeHce}
                parametrizacionSeleccionada={parametrizacionSeleccionada}
                setParametrizacionSeleccionada={setParametrizacionSeleccionada}                            
              />
            }
          </>
        );
      case 2:
        return (
          <>
            <GruposLaboratorio />
            {solicitudesAutorizadas.length > 0 && openModalEnCarga &&
              <SolicitudesLaboratorio
                open={openModalEnCarga}
                addedPracticasAndAbonar={addedPracticasAndAbonar}
                closeModalHandler={() => setOpenModalEnCarga(false)}
                parametrizacionSeleccionada={parametrizacionSeleccionada}
              />
            }
          </>
        );
      case 3:
        return (
          <Grid item xs={12} >
            <PracticasLaboratorioTabla 
              idObraSocial={idObraSocial}
              parametros={parametrizacionSeleccionada} 
            />
          </Grid>
        );
      case 4:
        return (
          <Grid item xs={12} >
            <PracticasLaboratorioSeleccionadas />
          </Grid>
        );
      case 5:
        return (
          <>
            <DiagnosticoFechaLaboratorio
              desdeHce={desdeHce}
              diagnostico={diagnostico}
              setDiagnostico={setDiagnostico}
              fechaPrescripcion={fechaPrescripcion}
              datosCompletos={datosCompletosDiagnostico}
              setFechaPrescripcion={setFechaPrescripcion}
              setDatosCompletos={setDatosCompletosDiagnostico}
            />
            <Grid item xs={12} >
              <DocumentacionLaboratorio
                datosCompletos={datosCompletosDocumentacion}
                setDatosCompletos={setDatosCompletosDocumentacion}
              />
            </Grid>
          </>
        );
      default:
        return "Unknown step";
    }
  };

  const handleDecision = (decicion = false) => {
    if(decicion){
      setOpenModalPregunta(false)
      dispatch(changeStepper(step + 1))
    }else{
      setOpenModalPregunta(false)
    }
  }

  return (
    <div className={classes.root}>
      <Stepper
        nonLinear
        activeStep={step}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* <ModalMultiSesion open={abrirModalMultiSesion} onClose={closeModalMultiSesionHandler} /> */}
      <div>
        <Grid container justify="center">
          {getStepContent(step)}
        </Grid>
        {openModalPregunta &&
          <AlertaMail
            open={openModalPregunta}
            setOpen={setOpenModalPregunta}
            mensaje={'No todas las prácticas se autorizaron automaticamente, algunas requieren Autorización, desea continuar?'}
            handleDecisionYes={() => handleDecision(true)}
            handleDecisionNo={handleDecision}
          />
        }
        <div className={classes.rootBotonera}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.botonera}
            style={{marginBottom: (!seleccionado || (afiliado && afiliado.fecha_baja !== null) 
              || !idObraSocial || Object.keys(parametrizacionSeleccionada).length === 0) && 55}
            }
          >
            {seleccionado &&
              <>
                {step !== 0 && !(desdeHce && step === 1) &&
                  <Button
                    variant="contained"
                    disabled={step === 0}
                    onClick={handleBack}
                    color="secondary"
                  >
                    Anterior
                  </Button>
                }
                {(afiliado && afiliado.fecha_baja !== null) || ((!idObraSocial || Object.keys(parametrizacionSeleccionada).length === 0) && !desdeHce)
                  ?
                    null
                  :
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      style={{marginLeft: (step === 0 || (desdeHce && step === 1)) && 'auto'}}
                      disabled={afiliado.sinFichaAfiliacion ? true : false}
                    >
                      {step === steps.length - 1 ? "Confirmar" : "Siguiente"}
                    </Button>
                }
              </>
            }
          </Grid>
        </div>
      </div>      
    </div>
  );
}